/**
 * A screen that needs a tablet or a desktop, on a phone: a sentence and a way
 * back instead of the screen.
 *
 * Moved out of `App.tsx` unchanged (TRBUD-439) so a route's own module — the
 * Reports pages' seam among them — can wrap what it renders without importing
 * the router file.
 */
import { Link } from "react-router-dom";
import { useIsCompact } from "../lib/useIsCompact";

export function RequireTablet({ screen, children }: { screen: string; children: React.ReactNode }) {
  const compact = useIsCompact();
  if (!compact) return <>{children}</>;
  return (
    <div className="screen-body device-required" role="status">
      {/* A heading and its own sentence are one section, not two — see the
          section rhythm in industry.css. */}
      <h3 className="section-attached">{screen} needs a larger screen</h3>
      <p className="text-muted section-attached">Use a tablet or desktop for this configuration-heavy view.</p>
      <Link className="btn btn-primary" to="/work-orders">Return to work orders</Link>
    </div>
  );
}
